import { z } from "zod";
import type {
  LoginRequest,
  CreateMemberRequest,
} from "../types/swagger";

// ===== LoginRequest =====
export const loginSchema = z.object({
  login_id: z.string().min(1, "ログインIDを入力してください").max(255, "ログインIDが長すぎます"),
  password: z.string().min(1, "パスワードを入力してください").max(128, "パスワードが長すぎます"),
}) satisfies z.ZodType<LoginRequest>;

// ===== CreateMemberRequest =====
export const createMemberSchema = z.object({
  login_id: z.string().min(1, "ログインIDを入力してください"),
  password: z.string().min(8, "パスワードは8文字以上で入力してください"),
  dartslive_card_name: z.string().min(1, "ダーツカード名を入力してください"),
}) satisfies z.ZodType<CreateMemberRequest>;

// infer した型（フォームで使う場合に利用）
export type LoginFormValues = z.infer<typeof loginSchema>;
export type CreateMemberFormValues = z.infer<typeof createMemberSchema>;
